import * as helpers from '../components/helpers';
import t from 'tcomb';

const SelectedPostingDate = t.struct({
    postingDateFrom: t.maybe(t.Number),
    postingDateTo: t.maybe(t.Number)
}, {
    name: 'SelectedPostingDate',
    strict: true
});

/* eslint-disable babel/new-cap */

export const getDefaultState = () =>
    new SelectedPostingDate(
        helpers.getReimbursementSummaryPostingDateValues.MTD(new Date())
    );

/* eslint-enable */

export default SelectedPostingDate;



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/state/selected-posting-date.js